const MIN_YEAR = 2025
const MAX_YEAR = 2028

export const getInitialDate = () => {
	const today = new Date()

	const initialDate = today.getFullYear() < MIN_YEAR
		? new Date(MIN_YEAR, 0)
		: today.getFullYear() > MAX_YEAR
		? new Date(MAX_YEAR, 11)
		: today

	return initialDate
}
